<template>

  <div class="wrap">

    <div class="page-header">
        <Nav :activeId="activeId" />
    </div>

    <!-- 头 -->
    <div class="section-one">
      <img src="../../img/product-3/banner.jpg" />

      <div class="nav-bar">
        <div class="nav-bar_label">PRODUCTS AND TECHNOLOGY</div>
        <div class="nav-bar_bread">
          <a href="/home">首页</a><span>产品与技术</span>排水产品系统
        </div>
        <!-- <img src="../../img/product-3/nav-top.png" c lass="product p-3" /> -->
      </div>

      <img src="../../img/product-3/title.png" class="v-c-title product-3-title" />
    </div>

    <!-- 产品信息 -->
    <div class="section-middle">
      <div class="item">
        <img src="../../img/product-3/info-left.jpg" />
      </div>

      <div class="item">
        <img src="../../img/product-3/info-right.jpg" />
      </div>
    </div>

    <!-- 尾 -->
    <div class="section-one">
      <img src="../../img/product-3/bg1.jpg" class="bg" />

      <div class="product-3-info">
        <img src="../../img/product-3/bg-info.png" class="" />
      </div>
    </div>

    <Footer />
  </div>

</template>

<script>
// import $ from 'jquery'
import Nav from '../components/Nav.vue'
import Footer from '../components/Footer.vue'
export default {
  data() {
    return {
      activeId: 1
    }
  },
  components: {
    Nav,
    Footer
  },
  mounted() {}
};
</script>

<style scoped lang="less">
</style>